import { AlertTriangle } from 'lucide-react';
import { useAuth, LoadingSpinner } from '@/shared';
import { SettingsPage } from '@/features/settings';

export function SettingsPageRoute() {
  const { isLoading, isAuthenticated, shop } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated || !shop) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 max-w-md">
          <div className="flex gap-3">
            <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
            <div>
              <h3 className="font-medium text-amber-800">Authentication Required</h3>
              <p className="mt-1 text-sm text-amber-700">
                Please authenticate to access the settings page.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="px-8 md:px-12 lg:px-16 py-6">
        <SettingsPage />
      </div>
    </div>
  );
}
